import {useState} from "react";
import {useHistory} from "react-router";
import {IonCol, IonGrid, IonRow} from "@ionic/react";

// GraphQL
import {useQuery} from "@apollo/client";
import {GET_MY_SINGLE_ORDER} from "../../../../graphql/queries/myorder.query";

// Custom Components
import Orders from "../../Attesa/Order";
import {Breadcrumbs} from "../../../../components";
import {isDateExpired} from "../../../../lib/utils/date-checker";

export default function EditServizi() {
  const history: any = useHistory();

  const orderId = history.location.pathname.split("/").slice(-1)[0];
  if (!/^\d+$/.test(orderId)) {
    history.push("/personale/servizi");
    return <> </>;
  }
  const parsedId = parseInt(orderId);

  const [order, setOrder] = useState<any>(null);

  useQuery(GET_MY_SINGLE_ORDER, {
    variables: {
      id: parsedId,
    },
    fetchPolicy: "cache-and-network",
    onCompleted: async (data) => {
      const orderData = data.getMyOrderDetail.data;
      setOrder(orderData);
    },
  });

  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Le mie pratiche", link: "/personale/servizi"},
    {title: order?.orderNumber},
  ];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      {!order && (
        <div className="attesa-no-service-text">
          Nessun servizio selezionato
        </div>
      )}

      {order && (
        <IonGrid>
          {isDateExpired(order?.agency?.expiresAt) && (
            <IonRow>
              <IonCol>
                <span style={{color: "red", fontWeight: "bold"}}>
                  Attenzione, il documento di identità risulta essere scaduto.
                  Aggiornalo al piu presto nel tuo profilo personale
                </span>
              </IonCol>
            </IonRow>
          )}

          <Orders
            data={order?.orderedService ?? []}
            isOutputType={true}
            orderData={order}
            note={order?.note ?? ""}
            secondaryNote={order?.secondaryNote ?? ""}
          />
        </IonGrid>
      )}
    </div>
  );
}
